import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "content-section" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h1", { class: "h2 mb-3 text-center" }, "Min profil", -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "card card-feat" }
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = { class: "col-sm-6 mb-3" }
const _hoisted_8 = { class: "col-sm-6 mb-3" }
const _hoisted_9 = { class: "col-sm-6 mb-3" }
const _hoisted_10 = /*#__PURE__*/_createStaticVNode("<h3 class=\"message-title-dropdown\"> Önskar du notifikation via SMS? </h3><div><div class=\"row\"><div class=\"col-10\"><input type=\"checkbox\" class=\"bigger-checkbox\"><span> Ja tack, jag vill bli noterad via SMS gällande mina låneansökningar på Ordna. </span></div></div></div><div class=\"container justify-content-start\"><div class=\"row\"><div class=\"col-md-6\"><button type=\"submit\" class=\"btn btn-primary mt-3\"> Spara ändringar </button></div></div></div>", 3)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TextField = _resolveComponent("TextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!_ctx.app || !_ctx.app.loanStatus)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _hoisted_4))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("form", {
          onSubmit: _cache[3] || (_cache[3] = _withModifiers(
//@ts-ignore
(...args) => ($options.submit && $options.submit(...args)), ["prevent"]))
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_TextField, {
              label: "Mobilnummer",
              modelValue: _ctx.form.mobilePhone,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.mobilePhone) = $event)),
              required: true,
              numbersOnly: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_TextField, {
              label: "Telefonnummer",
              modelValue: _ctx.form.phoneNumber,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.phoneNumber) = $event)),
              required: true,
              numbersOnly: true
            }, null, 8, ["modelValue"])
          ]),
          _createElementVNode("div", _hoisted_9, [
            _createVNode(_component_TextField, {
              label: "E-pos",
              modelValue: _ctx.form.email,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.email) = $event)),
              required: true,
              numbersOnly: false
            }, null, 8, ["modelValue"])
          ]),
          _hoisted_10
        ], 32)
      ])
    ])
  ]))
}